var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.308,
    height: 60.308,
    viewBox: "0 0 60.308 60.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guino",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    transform: "translate(14.698 35.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76",
    "data-name": "Grupo 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_215",
    "data-name": "Trazado 215",
    d: "M154.364,301.052a1.767,1.767,0,0,0-2.151,1.271,12.373,12.373,0,0,1-23.957,0,1.767,1.767,0,1,0-3.422.881,15.906,15.906,0,0,0,30.8,0A1.767,1.767,0,0,0,154.364,301.052Z",
    transform: "translate(-124.777 -300.996)",
    fill: "#e51b26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_79",
    "data-name": "Grupo 79",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    "data-name": "Grupo 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_216",
    "data-name": "Trazado 216",
    d: "M30.154,0A30.154,30.154,0,1,0,60.308,30.154,30.219,30.219,0,0,0,30.154,0Zm0,56.775A26.621,26.621,0,1,1,56.775,30.154,26.651,26.651,0,0,1,30.154,56.775Z",
    fill: "#e51b26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81",
    transform: "translate(35.457 17.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_80",
    "data-name": "Grupo 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_217",
    "data-name": "Trazado 217",
    d: "M310.638,158.251l-3.907-1.953,3.907-1.953a1.767,1.767,0,1,0-1.58-3.161l-7.067,3.534a1.768,1.768,0,0,0,0,3.161l7.067,3.534a1.767,1.767,0,1,0,1.58-3.161Z",
    transform: "translate(-301.015 -150.996)",
    fill: "#e51b26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    transform: "translate(14.253 17.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_82",
    "data-name": "Grupo 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_218",
    "data-name": "Trazado 218",
    d: "M126.3,151a5.3,5.3,0,1,0,5.3,5.3A5.307,5.307,0,0,0,126.3,151Zm0,7.067a1.767,1.767,0,1,1,1.767-1.767A1.769,1.769,0,0,1,126.3,158.067Z",
    transform: "translate(-121 -151)",
    fill: "#e51b26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexible);
export default __webpack_public_path__ + "static/media/flexible.c3e18d28dd68c81ab7e2bd973691fece.svg";
export { ForwardRef as ReactComponent };